import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';
import { mergeMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Subscription } from '../subscription.models';
import { QueryParams } from '../../models/http.models';
import { selectAccountId } from '../../account/store/account.selectors';
import { AppState } from '../../store';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionsResource {
  private apiRoot: string = `${process.env.API_URL}`;

  constructor(private http: HttpClient, private store: Store<AppState>) {}

  get(params?: QueryParams): Observable<Subscription> {
    return this.store.pipe(
      selectAccountId,
      mergeMap((account_id) =>
        this.http.get<Subscription>(`${this.apiRoot}/${account_id}/api/subscription`, { params }),
      ),
    );
  }
}

((window as any).xplenty as angular.IModule).service('Subscription', downgradeInjectable(SubscriptionsResource));
